import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { openPrintPage } from '../../../Helpers/PrintHelper';
import styles from './PrintLink.module.css';

export default function PrintLink({ onClick }) {
    const chosenPattern = useSelector(state => state.app.chosenPattern);
    const patternColors = useSelector(state => state.app.patternColors);
    const displayColors = useSelector(state => state.app.displayColors);
    const selectedRoomscene = useSelector(state => state.app.selectedRoomscene);
    const selectedFloorProduct = useSelector(state => state.app.selectedFloorProduct);
    const size = useSelector(state => state.app.size);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        openPrintPage(chosenPattern, patternColors, displayColors, selectedRoomscene, selectedFloorProduct, size);
    };

    return (
        <button className={styles.viewBtn} onClick={handleClick}>
            Print Design
        </button>
    );
}

PrintLink.propTypes = {
    onClick: PropTypes.func,
};
